<template>
  <v-menu close-on-content-click
          open-on-hover offset-y
          close-delay="300">
    <template v-slot:activator="{ on }">
      <v-btn
        text
        class="normal-btn-text body-1 font-weight-bold ml-3"
        v-on="on"
      >
        Configurações
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        link
        to="/minha-empresa"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-domain</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Minha empresa</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasRoleConfiguradorAlcadaCompra"
        to="/alcadas-compra"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-tune</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Alçadas de compra</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasRoleConfiguradorAlcadaRequisicao"
        to="/alcadas-solicitacao"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-tune</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Alçadas de solicitação</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasAnyRoleRecebedoraNotificacao || !hasRoleGestorNotificacoes"
        to="/painel-notificacao"
        active-class="orange--text">
        <v-list-item-icon>
          <v-icon>mdi-bell</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Painel de notificações</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasRoleGestorCompras"
        to="/configuracoes-moedas"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-currency-usd</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Moedas</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasIntegracaoAtiva || (!hasRoleComprador && !hasRoleGestorCompras)"
        to="/integracao"
        active-class="orange--text">
        <v-list-item-icon>
          <v-icon>mdi-connection</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Integração</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('user', ['hasRoleGestorCompras', 'hasRoleConfiguradorAlcadaCompra', 'hasRoleConfiguradorAlcadaRequisicao', 'hasRoleComprador', 'hasRoleRequisicao', 'hasRoleAprovador', 'hasRoleAprovadorRequisicao', 'hasRoleGestorNotificacoes']),
    ...mapGetters('entidade', ['hasIntegracaoAtiva']),
    hasAnyRoleRecebedoraNotificacao() {
      return this.hasRoleRequisicao
      || this.hasRoleComprador
      || this.hasRoleAprovador
      || this.hasRoleAprovadorRequisicao;
    },
  },
};
</script>
